<style scoped>
label {
    font-weight: 600;
    font-size: 13px;
    color: #7a7a7a;
    text-transform: capitalize;
    margin-bottom: 2px;
}
p {
    border-radius: 3px;
    color: #535353;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 2px;
}
.text-view{
  border-bottom: 1px dashed #dddddd;
  padding: 0;
  margin: 8px 48px;
}
.dashed-border-bottom{
  border-bottom: 1px dashed #dddddd;
  padding: 0;
}

</style>
<style>
.symbol .katex-display .katex .mathnormal, .symbol .katex-display .katex{
  font-family: 'Manrope' !important;
  font-weight: 800 !important;
  font-size: 14px !important;
}
.symbol .katex-display{
  margin-top:2px !important;
  margin-right: 0 !important;
}
</style>
<template>
    <b-row class="text-view" >
      <b-col cols="2" class="mr-0 pl-0">  <label>{{label}}</label></b-col>
      <b-col v-if="value=='-'" class="ml-0 pr-0 d-flex justify-content-start align-item-start">
        <p>{{ value }}</p>
      </b-col>
      <b-col v-else class="ml-0 pr-0 ">
        <katex-element output="html" :displayMode="true" :expression="value"/>
        <b-row 
          v-for="(item,index) in formulaStructure" 
          :key="index" 
          align-v="start"
          :class="index == formulaStructure.length-1? 'mb-2':'dashed-border-bottom mb-2'">
          <b-col cols="2" >
              <katex-element class="symbol" output="html" :displayMode="true" :expression="item.symbol"/>
          </b-col>
          <b-col cols="auto" class="p-0"> 
            :
          </b-col>
          <b-col>
            <span style="font-style:normal; font-size:13px">
              {{item.description}}
            </span>
          </b-col>
        </b-row>
      </b-col>
      
    </b-row>
  
</template>

<script>
//import VueKatex from 'vue-katex';
import 'katex/dist/katex.min.css';
export default {
  components:{
   // 'vue-katex': VueKatex,
  },
  props: {
    label: {
      type: String,
    },
    value: {
      type: String,
    },
    formulaStructure:{
      type: Array
    }
  },
  data() {
    return {
      formula: "\\begin{aligned} P~Salinakes &=\\frac{JPMoTK}{JPM_{15-49}} x 100\\% \\\\ \\\\ P~Salifaskes &=\\frac{JPSalifaskes}{JPM_{15-49}} x 100\\% \\end{aligned}\\\\ \\\\ \\begin{aligned} \\texttt{Keterangan} \\\\ P~Salinakes &: \\texttt{Proporsi perempuan pernah kawin umur 15-49 tahun yang proses melahirkan terakhirnya ditolong oleh tenaga kesehatan terlatih}\\\\ P~Salifaskes &: \\texttt{Persentase perempuan pernah kawin umur 15-49 tahun yang proses melahirkan terakhirnya di fasilitas kesehatan}\\\\ JPMoTK &: \\texttt{Jumlah perempuan pernah kawin umur 15-49 tahun yang pernah melahirkan dan ditolong oleh tenaga kesehatan terlatih dalam dua tahun terakhir}\\\\ JPSalifaskes &: \\texttt{Jumlah perempuan pernah kawin umur 15-49 tahun yang proses melahirkan terakhirnya di fasilitas kesehatan}\\\\ JPM_{15-49} &: \\texttt{Jumlah perempuan pernah kawin umur 15-49 tahun yang pernah melahirkan dalam dua tahun terakhir} \\end{aligned}",
    };
  },
};
</script>